export const COUNTRIES = 'admin/countries';
export const CITIES = 'admin/geo_fetch?geotype=City&parent_geo_type=Country';

export const FETCH_PROEPRTIES = 'v1/oam/list_properties?page=0&page_size=100';
export const FETCH_PROPERTY_BASIC_INFO = 'v1/oam/basic_property_info/';
export const POST_PROPERTY = 'v1/oam/basic_property_info';
export const SCRAPE_OTA_DETAILS = 'v1/oam/trigger_scrape_kafka';
export const GET_SCRAPED_DETAILS = 'v1/oam/atlas_scrapped_property';

export const FETCH_LOCATION = '/partnerpage/api/search_location';
export const GET_EARNING_POTENTIAL = '/partnerpage/api/earning_potential';

export const SIGN_OUT = 'v1/oam/profiles/sign_out';

export const CREATE_COLD_PROPERTY = '/cold_properties';

export const TRANSLATION_AND_IMAGES = '/partnerpage/api/get_page_data';